import { API_ROUTE } from "../../../utils/constants.js";
import { baseApi } from "../baseApi.js";
import { getToken } from "../localStorageService.js";

export const staffAttendanceApi = baseApi.injectEndpoints({
  credentials: "include",
  endpoints: (builder) => ({
    getStaffAttendances: builder.query({
      query: ({ search, limit, page, status= 10, user_role }) => {
        return {
          url: `/api/${user_role}/${API_ROUTE.getStaffAttendances}${user_role === "client" ? "/get-staff-attendance" : ""}?search=${search}&limit=${limit}&page=${page}&status=${status}`,
          method: "GET",
          headers: {
            "Content-type": "application/json; charset=UTF-8",
            authorization: `Bearer ${getToken()}`,
          },
        };
      },
    }),
    updateStaffAttendance: builder.mutation({
      query: (user) => {
        return {
          url: `${API_ROUTE.updateStaffAttendance}/${user.id}`,
          method: "PATCH",
          body: user,
          headers: {
            "Content-type": "application/json; charset=UTF-8",
            authorization: getToken(),
          },
        };
      },
      keepUnusedDataFor: 0,
      refetchOnFocus: true,
    }),
    deleteStaffAttendance: builder.mutation({
      query: (user) => {
        return {
          url: `${API_ROUTE.deleteStaffAttendance}/${user.id}`,
          method: "DELETE",
          headers: {
            "Content-type": "application/json; charset=UTF-8",
            authorization: `Bearer ${getToken()}`,
          },
        };
      },
      keepUnusedDataFor: 0,
      refetchOnFocus: true,
    }),
    addCheckIn: builder.mutation({
      query: (user) => {
        return {
          url: API_ROUTE.addCheckIn,
          method: "POST",
          body: user,
          headers: {
            "Content-type": "application/json; charset=UTF-8",
            authorization: `Bearer ${getToken()}`,
          },
        };
      },
      keepUnusedDataFor: 0,
      refetchOnFocus: true,
    }),
    addCheckOut: builder.mutation({
      query: (user) => {
        return {
          url: API_ROUTE.addCheckOut,
          method: "POST",
          body: user,
          headers: {
            "Content-type": "application/json; charset=UTF-8",
            authorization: `Bearer ${getToken()}`,
          },
        };
      },
      keepUnusedDataFor: 0,
      refetchOnFocus: true,
    }),
  }),
});

export const {
  useAddStaffAttendanceMutation,
  useGetStaffAttendancesQuery,
  useUpdateStaffAttendanceMutation,
  useDeleteStaffAttendanceMutation,
  useAddCheckInMutation,
  useAddCheckOutMutation,
} = staffAttendanceApi;
